import React from 'react';
import {DatePollInfo} from "../../models/DatePollInfo";
import Calendar from "react-calendar";
import UserIconWrapper from "./UserIconWrapper";
import 'react-calendar/dist/Calendar.css';
import '../../styles/Calendar.scss';
import {useSetRecoilState} from "recoil";
import {Box} from "@mui/material";
import {isSameDate} from "../../utils/Utils";
import {Favorite} from "@mui/icons-material";
import {HILIGHT_COLOR} from "../../constants/constants";
import {bottomDrawerPollInfoState, openBottomDrawerState} from "../../states/appointment/overviewAtom";

interface AlfyCalendarProps {
    datePollInfos: DatePollInfo[];
    bestPollInfos: DatePollInfo[];
    activeDates: Date[];
}

const AlfyCalendar: React.FC<AlfyCalendarProps> = ({datePollInfos, bestPollInfos, activeDates}) => {
    const sortedActiveDates = [...activeDates].sort((a, b) => a.getUTCMilliseconds() - b.getUTCMilliseconds());
    const firstActiveDate = sortedActiveDates[0];
    const lastActiveDate = sortedActiveDates[sortedActiveDates.length - 1];
    const setOpenBottomDrawer = useSetRecoilState(openBottomDrawerState);
    const setBottomDrawerPollItemInfo = useSetRecoilState(bottomDrawerPollInfoState);

    return (
        <>
            <Calendar
                calendarType="gregory"
                locale="ko-KR"
                defaultValue={firstActiveDate}
                minDate={firstActiveDate}
                maxDate={lastActiveDate}
                minDetail={'month'}
                showNeighboringMonth={false}
                tileContent={({date, view}) => {
                    return (
                        <DaySlot date={date} view={view} pollData={datePollInfos} bestPollInfos={bestPollInfos} />
                    )
                }}
                onClickDay={(targetDate, event) => {
                    const targetDatePollInfo = datePollInfos
                        .find((datePollInfo) => datePollInfo.date.toDateString() === targetDate.toDateString()) ?? new DatePollInfo(targetDate, []);
                    setBottomDrawerPollItemInfo(targetDatePollInfo);
                    setOpenBottomDrawer(true);
                }}
            />
            <Box height={'20px'} sx={{borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', backgroundColor: 'white'}} />
        </>
    );
}

interface DaySlotProps {
    date: Date;
    view: string;
    pollData: DatePollInfo[];
    bestPollInfos: DatePollInfo[];
}

const DaySlot: React.FC<DaySlotProps> = ({ date, view, pollData, bestPollInfos }) => {
    if (view !== 'month') {
        return <></>;
    }
    const datePollInfo = pollData.find((datePollInfo) => datePollInfo.date.toDateString() === date.toDateString());
    if (!datePollInfo) {
        return <></>;
    }

    const isBest = bestPollInfos.find(datePollInfo => isSameDate(datePollInfo.date, date))
    return (
        <>
            <UserIconWrapper datePollInfo={datePollInfo} />
            {isBest && <Box marginTop={'6px'}><Favorite sx={{color: HILIGHT_COLOR, fontSize: '16px'}} /></Box>}
        </>
    );
};

export default AlfyCalendar